import React from "react";
import { LAYOUT_CONSTANTS } from "../../LAYOUT_CONSTANTS";
import { LensesV2ContextProvider } from "./LensesV2Context";
import { LensesV2FilterBar } from "./LensesV2FilterBar";
import { SentimentWidget } from "./SentimentWidget";
import { SignalsWidget } from "./SignalsWidget";
import { TopicsWidget } from "./TopicsWidget";
import { IssuesWidget } from "./IssuesWidget";
import { FeatureWidget } from "./FeatureWidget";
import { SegmentWidget } from "./SegmentWidget";

// LensesV2 tab — dev-only surface where we rebuild the lenses dashboard as a
// thin layer. Hidden on prod via config (see SM_Dashboard/index.js). The
// context provider holds the shared filtration state; the filter bar drives it;
// every widget reads findQuery from it. We add widgets here one at a time.
export function LensesV2Tab() {
  return (
    <LensesV2ContextProvider>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.4rem", paddingBottom: `${LAYOUT_CONSTANTS.pagePadding}px` }}>
        <LensesV2FilterBar />
        <SentimentWidget />
        <div style={{ display: "flex", gap: "1.4rem", alignItems: "flex-start" }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <SignalsWidget />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <TopicsWidget />
          </div>
        </div>
        <div style={{ display: "flex", gap: "1.4rem", alignItems: "flex-start" }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <IssuesWidget />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <FeatureWidget />
          </div>
        </div>
        <SegmentWidget />
      </div>
    </LensesV2ContextProvider>
  );
}
